export enum TaskCategoryType {
    Alarm = 1,
    Assessment = 2
}